import type { PagePuzzle } from "./page.ts";

/** The visitor's own date, "YYYY-MM-DD": everyone on the same local date gets the same photo. */
export function localDate(d: Date = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

type Fetch = (url: URL) => Promise<Response>;

/**
 * The daily puzzle for `date`, from the Worker's `/puzzle/{date}`, or null when there's none (not
 * started anywhere yet, or not published). `game` is the game's address with a trailing slash, so
 * photo paths ("/img/…") land under any base path. Throws when it can't be reached.
 */
export async function fetchDaily(date: string, game: URL, get: Fetch = (url) => fetch(url)): Promise<PagePuzzle | null> {
  const res = await get(new URL(`puzzle/${date}`, game));
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`puzzle/${date}: ${res.status}`);
  const p = (await res.json()) as PagePuzzle;
  const image = { ...p.image, url: new URL(p.image.url.replace(/^\//, ""), game).pathname };
  return { number: p.number, date: p.date, answer: p.answer, hint: p.hint, image, alt: p.alt, credit: p.credit };
}
